import React, { useState, useEffect } from 'react';
import { getFuturesPositions, closeAllFuturesPositions, closeFuturesPosition } from '../../services/ExchangeService';
import { PageTableCard } from '../../components/PrivatePage';
import { AppButton } from '../../components/AppButton/AppButton';
import '../../components/PrivatePage/private-page.css';
import PositionRow from './PositionRow';

/**
 * props:
 * - data
 */
function PositionsTable(props) {

    const [positions, setPositions] = useState([]);
    const [error, setError] = useState('');
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        setError('');

        if (props.data) {
            const positions = Array.isArray(props.data) ? props.data : [props.data];
            setPositions(positions.filter(p => parseFloat(p.notional) !== 0));
        }
        else {
            getFuturesPositions()
                .then(positions => setPositions(positions.filter(p => parseFloat(p.notional) !== 0)))
                .catch(err => {
                    console.error(err.response ? err.response.data : err.message);
                    setError(err.response ? err.response.data : err.message);
                })

            const timer = setTimeout(() => {
                setRefresh(Date.now());
            }, 60000);

            return () => clearTimeout(timer);
        }
    }, [refresh])

    function onCloseAllClick(event) {
        setError('');
        closeAllFuturesPositions()
            .then(result => setRefresh(Date.now()))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setError(err.response ? err.response.data : err.message);
            })
    }

    function onCloseClick(event) {
        setError("");
        const symbol = event.target.id.replace("close", "");
        closeFuturesPosition(symbol)
            .then(result => setRefresh(Date.now()))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setError(err.response ? err.response.data : err.message);
            })
    }

    return (
        <React.Fragment>
            <PageTableCard className="mt-3">
                <div className="private-page-section-header" style={{ padding: '1rem 1rem 0' }}>
                    <h2 className="private-page-section-title">Futures positions (USDT)</h2>
                </div>
                <div className="table-wrapper table-responsive">
                            <table className="table table-hover">
                                <thead className='thead-light'>
                                    <tr>
                                        <th className='border-bottom' scope="col">Symbol</th>
                                        <th className='border-bottom' scope="col">Size</th>
                                        <th className='border-bottom' scope="col">Entry Price</th>
                                        <th className='border-bottom' scope="col">Mark Price</th>
                                        <th className='border-bottom' scope="col">Liq. Price</th>
                                        <th className='border-bottom' scope="col">Margin</th>
                                        <th className='border-bottom' scope="col">PnL</th>
                                        <th className='border-bottom' scope="col">Close</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        positions && positions.length
                                            ? positions.map(item => <PositionRow key={item.symbol} data={item} onClose={onCloseClick} />)
                                            : <tr><td>No opened positions.</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                <div style={{ padding: '0.85rem 1rem 1rem', borderTop: '1px solid #e0f2fe' }}>
                    <div className="d-flex flex-wrap align-items-center gap-2">
                        <AppButton type="button" variant="secondary" size="sm" onClick={() => setRefresh(Date.now())}>
                            Sync
                        </AppButton>
                        {positions && positions.length ? (
                            <AppButton type="button" variant="logout" size="sm" onClick={onCloseAllClick}>
                                Close all
                            </AppButton>
                        ) : null}
                        {error ? (
                            <div className="private-page-notice private-page-notice--error mb-0" role="alert">
                                <span>{error}</span>
                            </div>
                        ) : null}
                    </div>
                </div>
            </PageTableCard>
        </React.Fragment>
    )
}

export default PositionsTable;